export default "__VITE_ASSET__CdYxOYfQ__"